var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('Intro'),_c('Followers'),_c('Media')],1),_c('b-col',{attrs:{"md":"8"}},[_c('Post')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }